import React, { useState } from 'react';
import { observer } from 'mobx-react';
import compose from 'helpers/compose';

//import { ExternalProductsStore } from 'stores/workflowStores/finances/externalProducts/externalProducts';
import { Currency } from 'enums';
import { AdminPortfoliosStore } from 'stores/admin/adminPortfolios';
import PortfolioModalDetails from './PortfolioModalDetails';
import PortfolioEditor from '../../Accounts/Edit/Plan/PortfolioEditor/PortfolioEditor';

interface Props {
  //opened: boolean;
  handleClose: () => void;
  portfolioId?: string;
  uid?: string;
  clone?: boolean;
  refresh: () => void;
  store: AdminPortfoliosStore;
}

export enum Section {
  DETAILS = 'DETAILS',
  ASSETS = 'ASSETS',
}

const ExternalProductModal: React.FC<Props> = ({
  portfolioId,
  uid,
  clone,
  //opened,
  handleClose,
  refresh,
  store,
}) => {
  //let formSubmitting = false;
  //const { fetchPortfolio } = store; //, handleSubmit, data, invalidLink
  const [section, setSection] = useState<Section>(Section.DETAILS);
  const [id, setId] = useState<string | undefined>(undefined);

  const close = (state?: boolean) => {
    setSection(Section.DETAILS);
    handleClose();
    store.resetData();
  };

  /*
  const loading = () => (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        minHeight: '8em',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.8)',
        zIndex: 1,
      }}
    >
      <LoadingIndicator size={56} />
    </div>
  );*/

  return (
    <>
      {section === Section.DETAILS ? (
        <PortfolioModalDetails
          store={store}
          portfolioId={portfolioId}
          clone={clone}
          handleClose={close}
          setSection={setSection}
          setId={setId}
        />
      ) : (
        <PortfolioEditor
          id={id || ''}
          uid={uid}
          isOpen={true}
          // FIXME
          handleOpen={handleClose}
          // FIXME
          currency={Currency.CZK}
          setSection={setSection}
          refresh={refresh}
        />

      )}
    </>
  );
};

export default compose(observer)(ExternalProductModal);
